import React from "react";
import { InView } from "react-intersection-observer";

import { DropdownItemPosition } from "../../types/inputs";

export const DropdownLabel: React.FunctionComponent<{
    label: string;
    position: DropdownItemPosition;
    onEndScroll?: () => void;
}> = ({ label, position, onEndScroll }): JSX.Element => {
    switch (position) {
        case DropdownItemPosition.LAST:
            return (
                <InView
                    as="span"
                    onChange={(inView) =>
                        inView && onEndScroll && onEndScroll()
                    }
                >
                    {label}
                </InView>
            );
        default:
            return <span>{label}</span>;
    }
};
